import { calendarDayToISO, calendarDayToLocalPickerDate, extractCalendarDayLocal, tryCalendarDayFromISO } from "~/utils/datetime";

const CALENDAR_DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function parseSavedFilterCalendarDay(value: unknown): Date | null {
  if (typeof value !== "string" || !CALENDAR_DAY_PATTERN.test(value)) {
    return null;
  }
  const day = tryCalendarDayFromISO(value);
  return day && calendarDayToISO(day) === value ? calendarDayToLocalPickerDate(day) : null;
}

export function serializeSavedFilterCalendarDay(value: Date | null | undefined): string {
  return value ? calendarDayToISO(extractCalendarDayLocal(value)) : "";
}
